.wrapper {
	flex: 1;
	display: grid;
	grid-template:
		"label info" auto
		"input input" 1fr /
		1fr 1fr;
	gap: var(--size-2);

	&:has(.error:not(:empty)) {
		grid-template:
			"label info" auto
			"input input" 1fr
			"message message" auto /
			1fr 1fr;
	}
}

.label {
	justify-self: start;
	grid-area: label;
	font-size: var(--text-caption);
}

.info {
	grid-area: info;
}

.contents {
	grid-area: input;
	display: flex;
	flex-direction: column;
	gap: var(--size-3);
}

.error {
	grid-area: message;
	font-size: var(--text-caption);
	color: var(--color-error-text);

	&:empty {
		display: none;
	}
}
